module.exports = __webpack_public_path__ + "static/lost-ocean-1ba4063dbae7ddc7aadcb241f78ae74d.jpg";